import cloneDeep from 'lodash/cloneDeep';

import { blueprintTraverseApply } from './blueprintTraverseApply';
import { generateNodeId } from './generateNodeId';

import type { Blueprint, CompiledBlueprint } from '../types';

export function compileBlueprint(
  input: Blueprint | CompiledBlueprint
): CompiledBlueprint {
  const blueprint = cloneDeep(input);
  blueprintTraverseApply(blueprint.root, node => {
    node.__self__ = node.__self__ ?? generateNodeId();
  });

  return blueprint as CompiledBlueprint;
}
